import axios from 'axios';

export const createProduct = (categoryId, data) =>
  axios
    .post('/api/ds-product', {
      op: 'create',
      item: {
        categoryId,
        ...data,
      },
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const updateProduct = (data) =>
  axios
    .post('/api/ds-product', {
      op: 'update',
      item: data,
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const listProducts = (categoryId) =>
  axios
    .post('/api/ds-product', {
      op: 'list',
      categoryId,
      convert: true,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const getProduct = (id) =>
  axios
    .post('/api/ds-product', {
      op: 'read',
      item: { id },
      convert: true,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const deleteProduct = (id) =>
  axios
    .post('/api/ds-product', { op: 'delete', item: { id } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const deleteItem = (id) =>
  axios
    .post('/api/ds-item', { op: 'delete', item: { id } })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const addAttributeProductValue = (productId, attributeValues) =>
  axios
    .post('/api/add-product-attribute-values', {
      productId: parseInt(productId, 10),
      attributeValues,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const addItem = (productId, values) =>
  axios
    .post('/api/ds-item', {
      op: 'create',
      item: {
        productId: parseInt(productId, 10),
        ...values,
      },
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const getItem = (id) =>
  axios
    .post('/api/ds-item', {
      op: 'read',
      item: { id },
      convert: true,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));

export const updateItem = (data) =>
  axios
    .post('/api/ds-item', {
      op: 'update',
      item: data,
    })
    .then((response) => ({ data: response.data, success: true }))
    .catch((error) => ({ success: false }));

export const addAttributeItemValue = (itemId, arr) =>
  axios
    .post('/api/add-item-attribute-values', {
      itemId: parseInt(itemId, 10),
      attributeValues: arr,
    })
    .then((response) => response.data)
    .catch((error) => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/products/_api.js